export const ANALYSIS_QUERY_KEYS = {
  RESULT: (id: string) => ['resultData', id] as const,
  IMAGE: (id: string) => ['imageData', id] as const,
  DOWNLOAD: (id: string) => ['downloadData', id] as const,
  FONT: (id: string, pageIndex: number) => ['fontData', id, pageIndex] as const,
  ANOMALY: (id: string, pageIndex: number) =>
    ['anomalyData', id, pageIndex] as const,
  MRZ: (id: string, pageIndex: number) => ['mrzData', id, pageIndex] as const,
  NOTES: (id: string) => ['notesData', id] as const,
  COMPARE: (id: string, pageIndex: number) =>
    ['compareData', id, pageIndex] as const,
  DDOC: (id: string, pageIndex: number) => ['ddocData', id, pageIndex] as const,
} as const;
